import { notificationService } from "client-app-core";
import * as t from "./actionTypes.js";
export { removeDockedCameraAndState } from "orion-components/Dock/Actions/index.js";
import { newNotificationAlert } from "../../actions.js";

const PAGE_SIZE = 50;

const matchesNotificationSearch = (notification, query = "") => {
	const normalizedQuery = String(query || "")
		.trim()
		.toLowerCase();

	if (!normalizedQuery) {
		return true;
	}

	const searchableText = `${notification?.subject || ""} ${notification?.body || ""}`.toLowerCase();
	return searchableText.includes(normalizedQuery);
};

export function startNotificationStream() {
	return function (dispatch, getState) {
		dispatch(fetchActiveNotificationsPage({ reset: true, rehydrateToasts: true }));
		notificationService.streamMyActiveNotifications(function (err, response) {
			if (err) {
				console.log(err);
			} else {
				switch (response.type) {
					case "change-batch": {
						const { query = "" } = getState().globalData.notifications.activePagination;
						const notifications = response.changes.map(item => {
							if (item.type === "remove") {
								item.old_val["remove"] = true;
								return item.old_val;
							}
							// Adding toasts for new notifications if enabled.
							if (item.type === "add") {
								const notificationEnabled =
									item.new_val?.display?.type && item.new_val?.display?.type !== "none";
								if (notificationEnabled) {
									dispatch(newNotificationAlert(item.new_val));
								}
							}
							return matchesNotificationSearch(item.new_val, query) ? item.new_val : null;
						});
						dispatch(notificationBatchReceived(notifications));
						break;
					}
					default:
				}
			}
		});
	};
}

export const activeNotificationsPageRequested = () => {
	return {
		type: t.ACTIVE_NOTIFICATIONS_PAGE_REQUESTED
	};
};

export const activeNotificationsPageReceived = ({ notifications, hasMore, offset, limit, reset, query, snapshot }) => {
	return {
		type: t.ACTIVE_NOTIFICATIONS_PAGE_RECEIVED,
		notifications,
		hasMore,
		offset,
		limit,
		reset,
		query,
		snapshot
	};
};

export const activeNotificationsPageFailed = () => {
	return {
		type: t.ACTIVE_NOTIFICATIONS_PAGE_FAILED
	};
};

export const fetchActiveNotificationsPage = ({ reset = false, rehydrateToasts = false } = {}) => {
	return (dispatch, getState) => {
		const { activePagination } = getState().globalData.notifications;
		const query = reset
			? String(activePagination.pendingQuery ?? activePagination.query ?? "")
			: String(activePagination.query ?? "");
		const snapshot = reset ? "" : String(activePagination.snapshot ?? "");

		if (activePagination.loading) {
			return;
		}

		if (!reset && !activePagination.hasMore) {
			return;
		}

		const offset = reset ? 0 : activePagination.offset;
		dispatch(activeNotificationsPageRequested());

		notificationService.getMyActiveNotifications({ limit: PAGE_SIZE, offset, query, snapshot }, (err, response) => {
			if (err) {
				console.log(err);
				dispatch(activeNotificationsPageFailed());
				return;
			}

			if (rehydrateToasts && reset) {
				const existingToastIds = new Set(
					(getState().appState?.dock?.dockData?.newAlerts || []).map(notification => notification.id)
				);
				(response.items || []).forEach(notification => {
					if (notification?.display?.type === "alert" && !existingToastIds.has(notification.id)) {
						dispatch(newNotificationAlert(notification));
					}
				});
			}

			dispatch(
				activeNotificationsPageReceived({
					notifications: response.items || [],
					hasMore: response.hasMore ?? false,
					offset: response.offset ?? offset,
					limit: response.limit ?? PAGE_SIZE,
					reset,
					query: response.query ?? query,
					snapshot: response.snapshot ?? snapshot
				})
			);
		});
	};
};

export const setActiveNotificationsQuery = query => {
	return {
		type: t.SET_ACTIVE_NOTIFICATIONS_QUERY,
		query
	};
};

export const initialNotificationsReceived = notifications => {
	return {
		notifications,
		type: t.INITIAL_NOTIFICATIONS_RECEIVED
	};
};

export const notificationBatchReceived = notifications => {
	return {
		notifications,
		type: t.NOTIFICATION_BATCH_RECEIVED
	};
};

export const closeNotification = (notificationId, serviceType) => {
	return dispatch => {
		notificationService.closeNotification(notificationId, (err, response) => {
			if (err) {
				console.error("Error closing notification:", err);
				dispatch(fetchActiveNotificationsPage({ reset: true }));
				return;
			}
		});
		dispatch(
			notificationBatchReceived([
				{
					id: notificationId,
					remove: true
				}
			])
		);
	};
};

export const closeBulkNotifications = (notificationIds, serviceType) => {
	return dispatch => {
		notificationService.closeBulkNotifications(notificationIds, (err, response) => {
			if (err) {
				console.error("Error closing notifications:", err);
			}
		});
	};
};

export const closeNotificationsBefore = () => {
	return (dispatch, getState) => {
		const activeNotificationIds = Object.keys(getState().globalData?.notifications?.activeItemsById || {});
		const removedNotifications = activeNotificationIds.map(id => ({
			id,
			remove: true
		}));

		if (removedNotifications.length) {
			dispatch(notificationBatchReceived(removedNotifications));
		}

		notificationService.closeNotificationsBefore((err, response) => {
			if (err) {
				console.error("Error closing notifications by timestamp:", err);
				dispatch(fetchActiveNotificationsPage({ reset: true }));
				return;
			}

			const serverRemovedNotifications = (response?.successfulIds || []).map(id => ({
				id,
				remove: true
			}));

			if (serverRemovedNotifications.length) {
				dispatch(notificationBatchReceived(serverRemovedNotifications));
			}
		});
	};
};
